<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row class="slideshow-details">
      <b-col>
        <b-card title="جزئیات اسلایدشو">
          <b-form
            ref="slideshowform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>

                  <b-col

                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="نوع کالا"
                      label-for="DivisionId"
                    >
                      <z-division
                        v-model="Form.DivisionId"
                        :multiple="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="سبک"
                      label-for="StyleId"
                    >
                      <z-style
                        v-model="Form.StyleId"
                        :multiple="false"
                        :division-id="Form.DivisionId"
                        :disabled="!Form.DivisionId"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="بودجه"
                      label-for="BudgetId"
                    >
                      <z-budget
                        v-model="Form.BudgetId"
                        :multiple="false"
                        :style-id="Form.StyleId"
                        :disabled="!Form.StyleId"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-1">
                    <!-- تصویر و نقاط نشانه‌گذاری -->
                    <div
                      ref="imageContainer"
                      class="image-container"
                      @click="addMarker"
                    >
                      <img
                        ref="image"
                        :src="Form.Image"
                        alt="Annotatable Image"
                        @load="updateImageDimensions"
                      >
                      <div
                        v-for="(marker, index) in Form.SlideshowProduct"
                        v-if="marker.ProductId"
                        :key="index"
                        class="marker"
                        :style="{ top: (marker.Top * imageHeight) + 'px', left: (marker.Left * imageWidth) + 'px' }"
                        @click.stop="openModal(index)"
                      >
                        <div>
                          <feather-icon icon="CircleIcon" />
                        </div>
                        <b-badge
                          variant="info"
                          class="badge-label"
                        >
                          {{ product.filter(x => x.Id == marker.ProductId)[0].Title || 'بدون عنوان' }}
                        </b-badge>
                      </div>
                    </div>

                    <!-- مودال برای مدیریت نشانه‌ها -->
                    <b-modal
                      v-if="showModal"
                      id="marker-modal"
                      v-model="showModal"
                      hide-footer
                      title="جزئیات نقطه"
                      :no-close-on-backdrop="true"
                      size="sm"
                      centered
                    >
                      <b-form @submit.prevent="saveMarkerInfo">
                        <b-form-group
                          label="محصول"
                          label-for="ProductId"
                          class="mt-1 mb-3"
                        >
                          <z-product
                            v-model="currentMarker.ProductId"
                            :multiple="false"
                            :clearable="false"
                            required
                          />
                        </b-form-group>
                        <div
                          class="modal-footer"
                          style="padding-right: 0; padding-left: 0; padding-bottom: 0;"
                        >
                          <b-button
                            class="btn"
                            variant="outline-danger"
                            @click="deleteMarker"
                          >
                            حذف
                          </b-button>
                          <b-button
                            class="btn"
                            type="submit"
                            variant="primary"
                          >
                            ذخیره
                          </b-button>
                        </div>
                      </b-form>
                    </b-modal>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZDivision from '@/tools/division.vue'
import ZStyle from '@/tools/style.vue'
import ZBudget from '@/tools/budget.vue'
import ZProduct from '@/tools/product.vue'

export default {
  components: {
    ZDivision, ZStyle, ZBudget, ZProduct,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Description: null,
        BudgetId: null,
        IsActive: true,
        Image: null,
        SlideshowProduct: [],
      },
      loading: false,
      imageSrc: null, // آدرس عکس
      // markers: [], // ذخیره مختصات نسبی نشانه‌ها
      showModal: false, // مدیریت نمایش مدال
      currentMarker: null, // اطلاعات نشانه انتخاب‌شده
      currentIndex: null, // ایندکس نشانه انتخاب‌شده
      imageWidth: 0, // عرض تصویر
      imageHeight: 0, // ارتفاع تصویر
      product: [], // لیست محصولات
    }
  },
  created() {
    this.loading = true

    this.$http.post(this.$api.product.getall, {}).then(res => {
      this.product = res.data
      this.loading = false

      if (this.$route.params.id) {
        this.Form.Id = this.$route.params.id
        this.get()
      }
    })

    window.addEventListener('resize', this.updateImageDimensions)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateImageDimensions)
  },
  mounted() {
    this.updateImageDimensions()
  },
  methods: {
    save() {
      let url = this.$api.slideshow.add
      if (this.$route.params.id) {
        url = this.$api.slideshow.update
      }

      const formData = new FormData(this.$refs.slideshowform)
      formData.append('Id', this.Form.Id)
      formData.append('BudgetId', this.Form.BudgetId)
      formData.append('IsActive', this.Form.IsActive)

      this.Form.SlideshowProduct.forEach((item, index) => {
        if (item.ProductId) {
          formData.append(`SlideshowProduct[${index}].ProductId`, item.ProductId)
          formData.append(`SlideshowProduct[${index}].Top`, item.Top)
          formData.append(`SlideshowProduct[${index}].Left`, item.Left)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.slideshow.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          // this.imageSrc = this.Form.Image
        })
    },
    // افزودن نشانه جدید
    addMarker(event) {
      const rect = this.$refs.imageContainer.getBoundingClientRect()
      const x = (event.clientX - rect.left) / this.imageWidth
      const y = (event.clientY - rect.top) / this.imageHeight
      const newMarker = { Left: x, Top: y, ProductId: '' }
      this.Form.SlideshowProduct.push(newMarker)
      this.currentIndex = this.Form.SlideshowProduct.length - 1
      this.currentMarker = { ...newMarker }
      this.showModal = true
    },
    // باز کردن مدال
    openModal(index) {
      this.currentIndex = index
      this.currentMarker = { ...this.Form.SlideshowProduct[index] }
      this.showModal = true
    },
    // ذخیره اطلاعات نشانه
    saveMarkerInfo() {
      this.$set(this.Form.SlideshowProduct, this.currentIndex, this.currentMarker)
      this.showModal = false
    },
    // حذف نشانه
    deleteMarker() {
      if (confirm('آیا مطمئن هستید که می‌خواهید این نشانه را حذف کنید؟')) {
        this.Form.SlideshowProduct.splice(this.currentIndex, 1)
        this.showModal = false
      }
    },
    // به‌روزرسانی ابعاد تصویر
    updateImageDimensions() {
      const img = this.$refs.image
      if (img) {
        this.imageWidth = img.clientWidth
        this.imageHeight = img.clientHeight
      }
    },
  },
}
</script>

<style>
.slideshow-details .image-container {
  position: relative;
  display: inline-block;
}

.slideshow-details img {
  width: 100%;
  height: auto;
  display: block;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.slideshow-details .marker {
  position: absolute;
  cursor: pointer;
  text-align: right;

}

.slideshow-details .marker svg {
  color: #00cfe8;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
  stroke-width: 5px;
}
</style>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>